import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslationService } from '../../../services/translation/translation.service';

@Component({
  selector: 'app-editable-input',
  templateUrl: './editable-input.component.html',
  styleUrl: './editable-input.component.css'
})
export class EditableInputComponent {
  @Input() value!: string;
  @Output() valueChange = new EventEmitter<string>();

  isEditing = false;
  errorMessage: string | null = null;

  constructor(public translationService: TranslationService){}

  startEditing(e: MouseEvent) {
    e.preventDefault();
    e.stopPropagation();
    this.isEditing = true;
    this.errorMessage = null;
  }

  closeEditTitle(e: MouseEvent) {
    e.preventDefault();
    e.stopPropagation();

    if (this.value.trim() === '') {
      this.errorMessage = this.translationService.translate('The title cannot be empty');
    } else {
      this.isEditing = false;
      this.valueChange.emit(this.value);
      this.errorMessage = null;
    }
  }

  stopPropagation(e: Event) {
    e.stopPropagation();
  }

  handleKeyDown(event: KeyboardEvent) {
    if (event.key === ' ') {
      event.stopPropagation();
    }
  }
}
